import img1 from "./Picture 1.png"
import img2 from "./Picture 2.png"
import img3 from "./Picture 3.png"
import img4 from "./Picture 4.png"
import img5 from "./Picture 5.png"
import img6 from "./Picture 6.png"
import img7 from "./Picture 7.png"
import img8 from "./Picture 8.png"
import img9 from "./Picture 9.png"

export const imageData = {
    "images": [
        { 'key': '1', 'img': img1 },
        { 'key': '2', 'img': img2 },
        { 'key': '3', 'img': img3 },
        { 'key': '4', 'img': img4 },
        { 'key': '5', 'img': img5 },
        { 'key': '6', 'img': img6 },
        { 'key': '7', 'img': img7 },
        { 'key': '8', 'img': img8 },
        { 'key': '9', 'img': img9 }
    ]
}